module.exports = __webpack_public_path__ + "img/employer_benefit_empowerment.d19605e9.jpg";